import {
    listPrescription,
    addPrescription,
    updatePrescription,
    delPrescription,
    getPrescriptionDetail,
    transMedicalType
} from "@/api";
import {message} from "../../utils/common";
import {getMedicineConversionTargetType} from "@/assets/utils/medicineDosageForm";
import {getDecoctionName} from "@/assets/utils/decoction";
import Medicinal from "@/components/medicinal.vue";

export default {
    components: {
        Medicinal
    },
    data() {
        return {
            userInfo: null,
            currentPage: 1,
            pageNums: 20,
            totalCount: 0,
            queryParams: {
                docId: null,
                preName: null,
                billingType: null,
            },
            tableLoading: false,
            tableData: [],
            tableHeight: 500,
            indexMedicine: null,
            addDialogVisible: false,
            editDialogVisible: false,
            editPreId: "",
            preMedInfo: "",
            prescriptionInfo: {
                preName: "",
                instructions: "",
                docPrescriptionMedicineList: [],
                billingType: "0",
                isTop: '1'
            },
            medicineInfo: {
                medicineId: null,
                meName: null,
                price: null,
                gCount: null,
                newGCount: null,
                newRatio: null,
                standard: null,
                meRemark: null,
                mCount: null
            },
            medicinalChooseDrawer: false,
            direction: 'rtl',
            docMedicineArray: [],
            pagename: "prescription",
            newRuleOpen: false,
            transMedicineTypeData: {meType: null, medicineList: []},
            medicineTypeConversionRequestId: 0,
            isMedicineTypeConverting: false,
        }
    },
    mounted() {
        //此处需要通过延迟方法来设置值，不然会出现值已更新，但页面没更新的问题
        setTimeout(() => {
            this.tableHeight = window.innerHeight - this.$refs.multipleTable.$el.offsetTop - 80;
        }, 500)
    },
    created() {
        this.newRuleOpen = window.sessionStorage.getItem('newRuleOpen');
        this.userInfo = JSON.parse(window.sessionStorage.getItem("user"));
        this.doctorInfo = JSON.parse(window.sessionStorage.getItem("doctorInfo"));
        if (this.doctorInfo !== null && this.doctorInfo !== undefined && this.doctorInfo !== "") {
            this.queryDocId = this.doctorInfo.doctorId;
            this.getlistPrescription();
        }
        this.medicineList = JSON.parse(window.sessionStorage.getItem("medicineList"));
        if (this.medicineList !== null && this.medicineList !== "") {
            this.getMedicineList();
        }
    },
    methods: {

        // 选择剂型
        changeMedicineType() {
            const targetMedicineType = `${this.prescriptionInfo.billingType}`;
            const sourceMedicineType = `${this.indexMedicine}`;
            const hasMedicine = this.docMedicineArray.length > 0;
            const herbMedicineTypes = ['1', '2', '3'];
            const isHerbMedicineTypeChange = herbMedicineTypes.includes(sourceMedicineType) &&
                herbMedicineTypes.includes(targetMedicineType) && sourceMedicineType !== targetMedicineType;
            const canConvert = hasMedicine && sourceMedicineType !== targetMedicineType &&
                (sourceMedicineType === '0' && herbMedicineTypes.includes(targetMedicineType) ||
                    targetMedicineType === '0' && herbMedicineTypes.includes(sourceMedicineType));
            const applyTypeChange = () => {
                this.prescriptionInfo.billingType = targetMedicineType;
                this.indexMedicine = targetMedicineType;
                window.sessionStorage.setItem('billingType', targetMedicineType);
            };
            if (isHerbMedicineTypeChange) {
                this.$confirm('剂型已切换，药材仍使用饮片药材，是否继续?', '温馨提示', {
                    confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning'
                }).then(applyTypeChange).catch(() => {
                    this.prescriptionInfo.billingType = sourceMedicineType;
                });
                return;
            }
            const resetMedicine = () => {
                this.prescriptionInfo.docPrescriptionMedicineList = [];
                this.docMedicineArray = [];
                window.sessionStorage.removeItem('medicineList');
                window.sessionStorage.setItem('billingType', targetMedicineType);
                this.indexMedicine = targetMedicineType;
            };
            if (!canConvert) {
                if (hasMedicine && sourceMedicineType !== targetMedicineType) {
                    this.$confirm('更换开方剂型将重置已选的药品, 是否继续?', '温馨提示', {
                        confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning'
                    }).then(resetMedicine).catch(() => {
                        this.prescriptionInfo.billingType = sourceMedicineType;
                    });
                } else {
                    window.sessionStorage.setItem('billingType', targetMedicineType);
                    this.indexMedicine = targetMedicineType;
                }
                return;
            }
            this.$confirm('更换处方剂型将转换已选药品, 是否继续?', '温馨提示', {
                confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning'
            }).then(() => {
                this.transMedicineTypeData.meType = getMedicineConversionTargetType(targetMedicineType);
                this.transMedicineTypeForPrescription(sourceMedicineType, targetMedicineType);
            }).catch(() => {
                this.prescriptionInfo.billingType = sourceMedicineType;
            });
        },

        transMedicineTypeForPrescription(sourceMedicineType, targetMedicineType) {
            if (this.isMedicineTypeConverting) {
                return;
            }
            const conversionRequestId = ++this.medicineTypeConversionRequestId;
            this.isMedicineTypeConverting = true;
            const sourceMedicineList = JSON.parse(JSON.stringify(this.docMedicineArray));
            this.transMedicineTypeData.medicineList = sourceMedicineList.map((item, index) => ({
                medicineId: item.medicineId,
                countNum: sourceMedicineType === '0'
                    ? (item.newGCount === null || item.newGCount === undefined || item.newGCount === '' ? item.gCount : item.newGCount)
                    : (item.gCount === null || item.gCount === undefined || item.gCount === '' ? item.newGCount : item.gCount),
                meSeq: index
            }));
            transMedicalType(this.transMedicineTypeData).then(response => {
                if (conversionRequestId !== this.medicineTypeConversionRequestId) {
                    return;
                }
                if (response.code !== 200) {
                    throw new Error(response.msg || '药品剂型转换失败');
                }
                const transData = response.data || {};
                const resList = Array.isArray(transData.resList) ? transData.resList : [];
                const lackMedicineNames = String(transData.lackMedicine || '')
                    .split(/[,，、]/)
                    .map(name => name.replaceAll('配方', '').replaceAll('颗粒', '').replaceAll('饮片', '').trim())
                    .filter(Boolean);
                const isLackMedicine = (medicine) => {
                    const medicineName = (medicine.meName || '').replaceAll('配方', '').replaceAll('颗粒', '').replaceAll('饮片', '').trim();
                    return lackMedicineNames.some(name => medicineName.includes(name) || name.includes(medicineName));
                };
                if (resList.length === 0) {
                    throw new Error('药品剂型转换未返回有效药材，已保留原药材清单');
                }
                this.docMedicineArray = resList.map(melist => {
                    const newGCount = melist.newGCount === null || melist.newGCount === undefined ? melist.countNum : melist.newGCount;
                    const gCount = targetMedicineType === '0'
                        ? (this.newRuleOpen ? parseFloat(parseFloat(newGCount) * parseFloat(melist.newRatio)).toFixed(2) : newGCount)
                        : melist.countNum;
                    return {
                        medicineId: melist.medicineId,
                        meName: (melist.meName || '').replaceAll('配方', '').replaceAll('颗粒', '').replaceAll('饮片', ''),
                        price: melist.medicinePrice,
                        gCount, newGCount: targetMedicineType === '0' ? newGCount : gCount,
                        newRatio: melist.newRatio, standard: melist.standard, meRemark: melist.meDesc,
                        mCount: parseFloat(parseFloat(gCount) * parseFloat(melist.medicinePrice)).toFixed(2),
                        decoctionId: melist.decoctWay || '', decoctionName: getDecoctionName(melist.decoctWay),
                        decoctWay: melist.decoctWay || '',
                        drugProperty: melist.drugProperty || '', meStatus: melist.meStatus || '0',
                        isLimitUsage: melist.isLimitUsage, limitThreshold: melist.limitThreshold,
                        isLackMedicine: isLackMedicine(melist)
                    };
                }).sort((left, right) => Number(left.isLackMedicine) - Number(right.isLackMedicine));

                this.indexMedicine = targetMedicineType;
                this.prescriptionInfo.billingType = targetMedicineType;
                this.prescriptionInfo.docPrescriptionMedicineList = this.docMedicineArray;
                window.sessionStorage.setItem('billingType', targetMedicineType);
                window.sessionStorage.setItem('medicineList', JSON.stringify(this.docMedicineArray));
                const lackMedicine = transData.lackMedicine;
                if (lackMedicine) {
                    const lackMedicineText = lackMedicineNames.join('、');
                    message(`【${lackMedicineText}】药材有缺失，请替换或移除缺失药材！`, 'warning');
                }
            }).catch(error => {
                if (conversionRequestId !== this.medicineTypeConversionRequestId) {
                    return;
                }
                // 转换失败需要回滚剂型与药材，避免剂型单选框与实际药材不一致
                this.docMedicineArray = sourceMedicineList;
                this.prescriptionInfo.docPrescriptionMedicineList = sourceMedicineList;
                this.prescriptionInfo.billingType = sourceMedicineType;
                this.indexMedicine = sourceMedicineType;
                window.sessionStorage.setItem('billingType', sourceMedicineType);
                window.sessionStorage.setItem('medicineList', JSON.stringify(sourceMedicineList));
                message(error.message || error, 'error');
            }).finally(() => {
                if (conversionRequestId === this.medicineTypeConversionRequestId) {
                    this.isMedicineTypeConverting = false;
                }
            });
        },

        // 获取药材信息
        getMedicineList() {
            this.docMedicineArray = [];
            console.log(this.medicineList)
            this.medicineList.forEach(melist => {
                if (melist.meName !== null && melist.meName !== undefined) {
                    console.log("melist value >>> " + melist.medicineId);
                    melist.meName = melist.meName.replaceAll("配方", "").replaceAll("颗粒", "").replaceAll("饮片", "");
                    if (this.prescriptionInfo.billingType === "0") {
                        if (melist.newGCount === null) {
                            melist.newGCount = melist.gCount;
                        }
                        if (melist.newRatio === null) {
                            melist.newRatio = 1;
                        }
                        if (this.newRuleOpen) {
                            melist.gCount = parseFloat(parseFloat(melist.newGCount) * parseFloat(melist.newRatio)).toFixed(2);
                        } else {
                            melist.gCount = melist.newGCount;
                        }
                    } else {
                        melist.newGCount = melist.gCount;
                    }
                    this.docMedicineArray.push({
                        medicineId: melist.medicineId,
                        meName: melist.meName,
                        price: melist.price,
                        gCount: melist.gCount,
                        newGCount: melist.newGCount,
                        newRatio: melist.newRatio,
                        standard: melist.standard,
                        meRemark: melist.meRemark,
                        mCount: melist.mCount,
                        decoctionId: melist.decoctionId,
                        decoctionName: melist.decoctionName,
                        drugProperty: melist.drugProperty
                    });
                }
            })
            this.prescriptionInfo.docPrescriptionMedicineList = [];
            if (this.docMedicineArray.length > 0) {
                this.docMedicineArray.forEach(docMedlist => {
                    docMedlist.decoctWay = docMedlist.decoctionId;
                });
                this.prescriptionInfo.docPrescriptionMedicineList = this.docMedicineArray;
            }
        },


        changeData(name) {
            this.$router.push({path: '/admin/' + name});
            this.$store.state.adminleftnavnum = name; //设置左侧导航2-2 active
        },
        /** 重置按钮操作 */
        resetQuery() {
            this.queryParams.preName = "";
            this.queryParams.pageNum = "";
            this.queryParams.pageSize = "";
            this.getlistPrescription();
        },


        // 切换分页
        handleCurrentChange: function (val) {
            this.currentPage = val;
            this.getlistPrescription();
        },

        // 切换分页
        handleSizeChange: function (val) {
            this.pageNums = val;
            this.getlistPrescription();
        },


        // 获取医生处方模版
        getlistPrescription() {
            this.tableData = [];
            this.tableLoading = true;
            this.queryParams.docId = parseInt(this.queryDocId);
            this.queryParams.pageNum = this.currentPage;
            this.queryParams.pageSize = this.pageNums;
            this.queryParams.reasonable = "false";
            listPrescription(this.queryParams).then(res => {
                const rdata = res.data;
                console.log(rdata);
                this.tableLoading = false;
                if (rdata.code === 200) {
                    this.tableData = rdata.rows;
                    this.totalCount = rdata.total;
                    this.tableData.forEach((tbitem) => {
                        if (tbitem.billingType === "0") {
                            tbitem.billingTypeName = "颗粒";
                        } else if (tbitem.billingType === "1") {
                            tbitem.billingTypeName = "饮片";
                        } else if (tbitem.billingType === "2") {
                            tbitem.billingTypeName = "膏方";
                        } else if (tbitem.billingType === "3") {
                            tbitem.billingTypeName = "水丸";
                        }
                        let medInfo = "";
                        this.prescriptionInfo.docPrescriptionMedicineList = tbitem.docPrescriptionMedicineList;
                        if (this.prescriptionInfo.docPrescriptionMedicineList.length > 0) {
                            this.prescriptionInfo.docPrescriptionMedicineList.forEach(item => {
                                item.meName = item.meName.replaceAll("配方", "").replaceAll("颗粒", "").replaceAll("饮片", "");
                                medInfo += item.meName;
                                if (item.decoctionId !== null && item.decoctionId !== undefined && item.decoctionId !== '') {
                                    medInfo += "(" + item.decoctionName + ")";
                                }
                                if (item.decoctWay !== null && item.decoctWay !== undefined && item.decoctWay !== '') {
                                    medInfo += "(" + item.decoctWay + ")";
                                }
                                if (tbitem.billingType === "0") {
                                    if (item.newGCount === null) {
                                        item.newGCount = item.gCount;
                                    }
                                    if (this.newRuleOpen) {
                                        item.gCount = parseFloat(parseFloat(item.newGCount) * parseFloat(item.newRatio)).toFixed(2);
                                    } else {
                                        item.gCount = item.newGCount;
                                    }
                                } else {
                                    item.newGCount = item.gCount;
                                }
                                medInfo += "(" + item.newGCount + "g)" + ",";
                            })
                            medInfo = medInfo.replaceAll("配方", "").replaceAll("颗粒", "").replaceAll("饮片", "");
                            tbitem.preMedInfo = medInfo.substring(0, medInfo.length - 1);
                        }
                    })

                }
            }).catch(error => {
                message(error, "error");
            });
        },


        // 新增自建模版
        addNewPrescription() {
            this.pretype = "add";
            this.addDialogVisible = true;
            this.prescriptionInfo.preName = "";
            this.prescriptionInfo.instructions = "";
            this.prescriptionInfo.docPrescriptionMedicineList = [];
            this.prescriptionInfo.billingType = "0";
            this.prescriptionInfo.isTop = "";
        },


        // 修改自建模版
        editNewPrescription(index, tdata) {
            this.editPreId = tdata[index].preId;
            console.log(tdata[index]);
            this.pretype = "edit";
            this.editDialogVisible = true;

            let billingType = tdata[index].billingType;
            this.prescriptionInfo.billingType = billingType;
            this.indexMedicine = billingType;
            window.sessionStorage.removeItem('billingType');
            window.sessionStorage.setItem('billingType', this.prescriptionInfo.billingType);
            this.docMedicineArray = [];
            this.medicineList = [];
            window.sessionStorage.removeItem('medicineList');
            this.getPrescriptionDetailInfo(this.editPreId);
        },


        // 查询模版详细信息
        getPrescriptionDetailInfo(preId) {
            console.log("getPrescriptionInfo choosePreId >>>>> " + preId);
            getPrescriptionDetail(preId).then(response => {
                // console.log(response);
                this.prescriptionInfo = response.data.data;
                // 解析处方模版详情
                let isTop = this.prescriptionInfo.isTop;
                if (isTop !== null && isTop !== "" && isTop !== undefined) {
                    if (isTop === '0') {
                        this.isSetTop = true;
                    } else {
                        this.isSetTop = false;
                    }
                } else {
                    this.isSetTop = false;
                }

                if (this.medicineList !== null && this.medicineList !== "" && this.medicineList.length > 0) {
                    this.docMedicineArray = [];
                    this.medicineList.forEach(melist => {
                        if (melist.meName !== null && melist.meName !== "" && melist.meName !== undefined) {
                            melist.meName = melist.meName.replaceAll("配方", "").replaceAll("颗粒", "").replaceAll("饮片", "");
                            if (this.prescriptionInfo.billingType === "0") {
                                if (melist.newGCount === null) {
                                    melist.newGCount = melist.gCount;
                                }
                                if (this.newRuleOpen) {
                                    melist.gCount = parseFloat(parseFloat(melist.newGCount) * parseFloat(melist.newRatio)).toFixed(2);
                                } else {
                                    melist.gCount = melist.newGCount;
                                }
                            } else {
                                melist.newGCount = melist.gCount;
                            }
                            let mCount = parseFloat(parseFloat(melist.gCount) * parseFloat(melist.price)).toFixed(2);
                            this.docMedicineArray.push({
                                medicineId: melist.medicineId,
                                meName: melist.meName,
                                price: melist.price,
                                gCount: melist.gCount,
                                newGCount: melist.newGCount,
                                newRatio: melist.newRatio,
                                standard: melist.standard,
                                meRemark: melist.meRemark,
                                mCount: mCount,
                                decoctionId: melist.decoctionId,
                                decoctionName: melist.decoctionName,
                                drugProperty: melist.drugProperty
                            });
                        }

                    })
                }
                this.doMedicineList = this.prescriptionInfo.docPrescriptionMedicineList;
                // console.log(this.prescriptionInfo);
                this.docMedicineArrayPush(); // 将处方模版的药品拼接到药品列表中

            });
        },

        // 将处方模版的药品拼接到药品列表中
        docMedicineArrayPush() {
            console.log(this.doMedicineList);
            if (this.doMedicineList !== null && this.doMedicineList.length > 0) {
                this.doMedicineList.forEach((melist) => {
                    if (melist.meName !== null && melist.meName !== "" && melist.meName !== undefined) {
                        melist.meName = melist.meName.replaceAll("配方", "").replaceAll("颗粒", "").replaceAll("饮片", "");
                        if (this.prescriptionInfo.billingType === "0") {
                            if (melist.newGCount === null) {
                                melist.newGCount = melist.gCount;
                            }
                            if (this.newRuleOpen) {
                                melist.gCount = parseFloat(parseFloat(melist.newGCount) * parseFloat(melist.newRatio)).toFixed(2);
                            } else {
                                melist.gCount = melist.newGCount;
                            }
                        } else {
                            melist.newGCount = melist.gCount;
                        }
                        let mCount;
                        if (melist.gCount === "" || melist.gCount === null || melist.gCount === undefined) {
                            mCount = parseFloat(parseFloat(0) * parseFloat(melist.price)).toFixed(2);
                        } else {
                            mCount = parseFloat(parseFloat(melist.gCount) * parseFloat(melist.price)).toFixed(2);
                        }
                        this.docMedicineArray.push({
                            changeMed: false,
                            focusMeName: false,
                            focusGcount: false,
                            medicineId: melist.medicineId,
                            meName: melist.meName,
                            price: melist.price,
                            gCount: melist.gCount,
                            newGCount: melist.newGCount,
                            newRatio: melist.newRatio,
                            standard: melist.standard,
                            meRemark: melist.meRemark,
                            mCount: mCount,
                            decoctionId: melist.decoctionId,
                            decoctionName: melist.decoctionName,
                            decoctWay: melist.decoctWay
                        });
                    }
                })
                window.sessionStorage.removeItem('medicineList');
                window.sessionStorage.setItem('medicineList', JSON.stringify(this.docMedicineArray));
                this.prescriptionInfo.docPrescriptionMedicineList = [];
                this.prescriptionInfo.docPrescriptionMedicineList = this.docMedicineArray;
            }
        },


        // 确定修改常用处方
        editPrescriptionFun() {
            if (this.prescriptionInfo.preName === null || this.prescriptionInfo.preName === "" || this.prescriptionInfo.preName === undefined) {
                message("处方名称不能为空", "error");
            } else if (this.prescriptionInfo.docPrescriptionMedicineList.length <= 0) {
                message("处方药品不能为空", "error");
            } else {
                if (this.pretype === "add") {
                    addPrescription(this.prescriptionInfo).then(response => {
                        if (response.code === 200) {
                            message("新增成功", "success");
                            window.sessionStorage.removeItem('medicineList');
                            window.sessionStorage.removeItem('preId');
                            this.addDialogVisible = false;
                            this.getlistPrescription();
                        } else {
                            message("新增失败", "error");
                        }
                    });
                } else {
                    this.$confirm('确定要修改所选处方模版吗？', "温馨提示").then(() => {
                        updatePrescription(this.prescriptionInfo).then(response => {
                            if (response.code === 200) {
                                message("修改成功", "success");
                                window.sessionStorage.removeItem('medicineList');
                                window.sessionStorage.removeItem('preId');
                                this.editDialogVisible = false;
                                this.getlistPrescription();
                            } else {
                                message("修改失败", "error");
                            }
                        });
                    }).catch(() => {
                        console.log('用户取消');
                    })
                }
            }

        },

        // 取消修改常用处方
        cancelPrescriptionFun() {
            window.sessionStorage.removeItem('medicineList');
            window.sessionStorage.removeItem('preId');
            this.prescriptionInfo.preName = "";
            this.prescriptionInfo.instructions = "";
            this.prescriptionInfo.docPrescriptionMedicineList = [];
            this.prescriptionInfo.billingType = "0";
            this.prescriptionInfo.isTop = "";
            if (this.pretype === "add") {
                this.addDialogVisible = false;
            } else if (this.pretype === "edit") {
                this.editDialogVisible = false;
            }
        },

        // 删除处方模版
        deletePrescription(index, tdata) {
            this.$confirm('确定要删除所选处方模版吗？', "温馨提示").then(() => {
                delPrescription(tdata[index].preId).then((response) => {
                    if (response.code === 200) {
                        message("删除成功", "success");
                        this.getlistPrescription();
                    } else {
                        message("删除失败", "error");
                    }
                })
            }).catch(() => {
                console.log('用户取消');
            })
        },

        // 批量删除处方模版
        multipleDeletePrescription() {
            const selectedRows = this.$refs.multipleTable.getSelectionRows();
            if (selectedRows.length <= 0) {
                message("请至少选择一个处方模版！", "error");
            } else {
                this.$confirm('确定要删除所选处方模版吗？', "温馨提示").then(() => {
                    let ids = selectedRows.map(item => item.preId)
                    delPrescription(ids).then((response) => {
                        if (response.code === 200) {
                            message("删除成功", "success");
                            this.getlistPrescription();
                        } else {
                            message("删除失败", "error");
                        }
                    })
                }).catch(() => {
                    console.log('用户取消');
                })
            }
        },


        // 选择药材
        openChooseMedicinalDrawer() {
            this.medicinalChooseDrawer = true;
            this.billingType = "颗粒";
        },

        // 选择药材弹窗关闭
        getMedicinalDrawerStatus() {
            this.medicinalChooseDrawer = false;
            this.medicineList = JSON.parse(window.sessionStorage.getItem("medicineList"));
            this.getMedicineList();
        },


    }
}